/*
 * MOBILE-MATERIALS.ACTION.JS - Actions for Mobile Visible Materials
 *
 * SUMMARY:
 * Thunk actions that delegate to the API layer and return promises,
 * consistent with existing action patterns used across the app.
 */

import { getMobileVisibleMaterialsAPI, setMobileVisibleMaterialIdsAPI } from '../api/mobile-materials.api'

/**
 * Fetches mobile visible materials with full item details
 * @returns {Promise<{ids: string[], materials: Object[]}>}
 */
export const getMobileVisibleMaterialsAction = () => {
  return (dispatch, getState) => {
    return getMobileVisibleMaterialsAPI()
  }
}

export const setMobileVisibleMaterialIdsAction = (ids) => {
  return (dispatch, getState) => {
    return setMobileVisibleMaterialIdsAPI(ids)
  }
}


